/**
 * Removes rates without schedules when a rate with schedules exists
 * for the same origin, destination, and carrier.
 */
export const filterRatesWithoutSchedules = (rates) => {
  if (!Array.isArray(rates) || rates.length === 0) return rates;

  const groupHasSchedules = new Map();
  for (const rate of rates) {
    const key = `${rate.location_from?.id}-${rate.location_to?.id}-${rate.carrier?.id}`;
    if (rate.schedules) {
      groupHasSchedules.set(key, true);
    } else if (!groupHasSchedules.has(key)) {
      groupHasSchedules.set(key, false);
    }
  }

  const filtered = rates.filter((rate) => {
    const key = `${rate.location_from?.id}-${rate.location_to?.id}-${rate.carrier?.id}`;
    return rate.schedules || !groupHasSchedules.get(key);
  });

  // const removedRates = rates.filter((rate) => !filtered.includes(rate));
  // if (removedRates.length > 0) {
  //   console.log(`[filterRatesWithoutSchedules] Removed ${removedRates.length} rate(s) without schedules:`);
  //   removedRates.forEach((rate) => {
  //     console.log(
  //       `  ❌ id=${rate.id} | ${rate.location_from?.company_name} → ${rate.via_port?.company_name ?? 'N/A'} → ${rate.location_to?.company_name} | carrier=${rate.carrier?.company_name}`
  //     );
  //   });
  // } else {
  //   console.log('[filterRatesWithoutSchedules] No rates removed — all rates either have schedules or no scheduled alternative exists.');
  // }

  return filtered;
};
